import React from "react";

import { SaveType, postFileVersionDataJSON } from "../../../api/files";
import { DialogPhaseType } from "../../Dialog/helpers/hooks";
import { DragAndDropUploadData } from "../../DragAndDropFields";
import { useUploadSheetData } from "./useUploadSheetData";

/**
 * @description JSONアップ用の関数と状態を管理
 */
export const useUploadSheetDataJSON = (
  uploadedFileList: DragAndDropUploadData[],
  setUploadedFileList: React.Dispatch<
    React.SetStateAction<DragAndDropUploadData[]>
  >,
  uploadDialogPhaseType: DialogPhaseType,
  setUploadDialogPhaseType: (uploadDialogPhaseType: DialogPhaseType) => void,
  saveType: SaveType
) => {
  return useUploadSheetData(
    uploadedFileList,
    setUploadedFileList,
    uploadDialogPhaseType,
    setUploadDialogPhaseType,
    saveType,
    postFileVersionDataJSON
  );
};
